import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { Button, DropdownItemProps, Grid, Select } from 'semantic-ui-react';

import { ResumenMatricula } from 'src/modulos/Matriculas/comun/tipos';
import { nombreCompletoConNombresPrimero } from 'src/utilidades';

interface Props extends RouteComponentProps {
    listaDeMatriculas: Array<ResumenMatricula>;
}

class BuscadorBasico extends React.PureComponent<Props, { id?: number }> {
    public readonly state: { id?: number } = {};

    public render() {
        const id = this.state.id;

        return (
            <Grid>
                <Grid.Column width='14'>
                    <Select
                        options={this.props.listaDeMatriculas.reduce(
                            // efectúa un flatMap usando reduce y concat
                            (acc, proceso) =>
                                acc.concat(proceso.alumnos.map(this.convertir(proceso))),
                            [] as DropdownItemProps[],
                        )}
                        noResultsMessage='No hay resultados'
                        onChange={(_e, { value }) => this.setState({ id: value as number })}
                        search
                        deburr
                        fluid
                        icon=''
                    />
                </Grid.Column>
                <Grid.Column width='2'>
                    <Button
                        type='button'
                        content='Ir'
                        disabled={!id}
                        onClick={() => this.props.history.push(`supervision/matriculas/${id}`)}
                        fluid
                    />
                </Grid.Column>
            </Grid>
        );
    }

    private convertir(proceso: ResumenMatricula) {
        type Alumno = ResumenMatricula['alumnos'][number];
        return (alumno: Alumno, i: number): DropdownItemProps => {
            const numeroDeContrato = proceso.numerosDeContrato[i];
            const nombreAlumno = nombreCompletoConNombresPrimero(alumno.nombre);
            const nombreApoderado = nombreCompletoConNombresPrimero(proceso.apoderado.nombre);
            return {
                key: `${proceso.id}-${numeroDeContrato}`,
                value: proceso.id,
                text:
                    `Matrícula: ${numeroDeContrato}` +
                    ` - Alumno: ${nombreAlumno}` +
                    ` - Apoderado: ${nombreApoderado}`,
                content: (
                    <p>
                        <span style={{ color: 'grey' }}>Matrícula: </span>
                        {numeroDeContrato}
                        &emsp;
                        <span style={{ color: 'grey' }}>Alumno: </span>
                        {nombreAlumno}
                        &emsp;
                        <span style={{ color: 'grey' }}>Apoderado: </span>
                        {nombreApoderado}
                    </p>
                ),
            };
        };
    }
}

export default withRouter(BuscadorBasico);



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/ListaDeProcesos/TablaDeProcesos/BuscadorBasico.tsx